export default "__VITE_ASSET__CsL1FqrE__"